// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InfoClass {
    max-width: 35rem !important;
    padding-top: 4rem;
}
.InfoClass .modal-body{
    min-height: 15rem !important;
}
.questionInfoTable tbody{
    overflow-y: scroll;
    height: 25rem;
    display: block;
}
.questionInfoTable tr{
    display: block;

}

.quesInfoModal-toyota .modal-dialog, .quesInfoModal-toyota .modal-content {
    border-radius: 24px !important;
    border: 1px solid #e50000 !important;
}

.quesInfoModal-lexus .modal-dialog, .quesInfoModal-lexus .modal-content {
    border-radius: 24px !important;
    border: 1px solid #252525 !important;
}

.quesInfoModal-toyota .modal-header {
    background-color: #e50000;
    border-top-left-radius: 20px !important;
    border-top-right-radius: 20px !important;
    padding: 0.5rem !important;
}

.quesInfoModal-lexus .modal-header {
    background-color: #252525;
    border-top-left-radius: 20px !important;
    border-top-right-radius: 20px !important;
    padding: 0.5rem !important;
}

.quesInfoModal-toyota .textFont {
    color: #e50000;
}

.quesInfoModal-lexus .textFont {
    color: #252525;
}

.quesInfoModal-toyota .textFontHistory {
    color: #e50000;
    margin: 0px;
}

.quesInfoModal-lexus .textFontHistory {
    color: #252525;
    margin: 0px;
}

.quesInfoModal-toyota .css-10nd86i svg {
    color: #e50000;
}

.quesInfoModal-lexus .css-10nd86i svg {
    color: #252525;
}`, "",{"version":3,"sources":["webpack://./src/components/questionInfo/index.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,iBAAiB;AACrB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;AAClB;AACA;IACI,cAAc;;AAElB;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".InfoClass {\n    max-width: 35rem !important;\n    padding-top: 4rem;\n}\n.InfoClass .modal-body{\n    min-height: 15rem !important;\n}\n.questionInfoTable tbody{\n    overflow-y: scroll;\n    height: 25rem;\n    display: block;\n}\n.questionInfoTable tr{\n    display: block;\n\n}\n\n.quesInfoModal-toyota .modal-dialog, .quesInfoModal-toyota .modal-content {\n    border-radius: 24px !important;\n    border: 1px solid #e50000 !important;\n}\n\n.quesInfoModal-lexus .modal-dialog, .quesInfoModal-lexus .modal-content {\n    border-radius: 24px !important;\n    border: 1px solid #252525 !important;\n}\n\n.quesInfoModal-toyota .modal-header {\n    background-color: #e50000;\n    border-top-left-radius: 20px !important;\n    border-top-right-radius: 20px !important;\n    padding: 0.5rem !important;\n}\n\n.quesInfoModal-lexus .modal-header {\n    background-color: #252525;\n    border-top-left-radius: 20px !important;\n    border-top-right-radius: 20px !important;\n    padding: 0.5rem !important;\n}\n\n.quesInfoModal-toyota .textFont {\n    color: #e50000;\n}\n\n.quesInfoModal-lexus .textFont {\n    color: #252525;\n}\n\n.quesInfoModal-toyota .textFontHistory {\n    color: #e50000;\n    margin: 0px;\n}\n\n.quesInfoModal-lexus .textFontHistory {\n    color: #252525;\n    margin: 0px;\n}\n\n.quesInfoModal-toyota .css-10nd86i svg {\n    color: #e50000;\n}\n\n.quesInfoModal-lexus .css-10nd86i svg {\n    color: #252525;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
